import React from 'react';
import { BsFillPeopleFill } from "react-icons/bs";
import cardIcon from "../../assets/Images/CardIcon.svg"; 
import { MdBubbleChart } from "react-icons/md";

function CourseCard({cardData,currentCard,setCurrentCard}) {
    return (
        <div className='' onClick={()=>{
            setCurrentCard(cardData.heading);
        }}>
            <div className={`w-[18rem] h-[18rem] py-9 px-4 ${currentCard === cardData.heading ? ("inset-20 shadow-[rgba(255,214,10,1)_15px_15px_0px_0px] bg-white") : ("bg-richblack-700")}  flex flex-col justify-between transition-all duration-200`}>
                <div className='flex flex-col gap-y-4'>
                    <div className={`text-xl font-semibold text-start  ${currentCard === cardData.heading ? ("text-richblack-800") : ("text-richblack-200")} `} >{cardData.heading}</div>
                    <div className={`${currentCard === cardData.heading ? ("text-richblack-500") : ("text-richblack-200")} `}>{cardData.description}</div>
                </div>
                <div className={`flex flex-row justify-between text-md ${currentCard === cardData.heading ? ("text-blue-200") : ("text-richblack-300")} border-t-2 border-dashed border-richblack-50`}>
                    <div className='flex gap-x-2 items-center mt-3'>
                        <BsFillPeopleFill /><div>{cardData.level}</div>
                        </div>
                    <div className='flex gap-x-2 items-center mt-3'>
                        <MdBubbleChart />
                        <div>{cardData.lessionNumber} Lessons</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CourseCard;